import { TAX_SYSTEM_TYPE } from "@helpers/constantes";
import { ExpedientePM } from "./pm/ExpedientePM";
import { ExpedientePF } from "./pf/ExpedientePF";
import { ExpedientePFAE } from "./pfae/ExpedientePFAE";
import { RootState } from "@store/store";
import { useSelector } from "react-redux";

export const Expediente = () => {
  const taxType = useSelector((state: RootState) => state.register.application?.tax_system_type);

  if (taxType === TAX_SYSTEM_TYPE.PF.code) return <ExpedientePF />;
  if (taxType === TAX_SYSTEM_TYPE.PFAE.code) return <ExpedientePFAE />;

  return <ExpedientePM />;
};
